import React, { useState, useEffect, useRef } from 'react';
import { getBitvilleIframeData } from 'integrationActions.js'
import Loader from 'Loader.js';
import { useSelector, useDispatch, connect } from 'react-redux'
import { getIsLogged } from 'authSelector.js'

import S from 'StyledBitville';

const BitvilleContainer = ({providerData}, currencyCode) => {

    if (providerData) {
        setBitvilleData(providerData, currencyCode);
    }

    return (providerData) ? 
        (
            <S.BitvilleContainer id="load-lotteries"/>
        )
        : 
        (
            <S.Cover><Loader color="#F05A22"/></S.Cover>
        );
  }

const setBitvilleData = (iframeData, currencyCode) => {
    const script = document.createElement('script');
    const {gaming_engine_url} = iframeData;

    script.src = process.env.BITVILLE_SCRIPT_URL.replace('{gaming_engine_url}', gaming_engine_url);
    script.async = true;
    script.onload = () => createBitvilleIframe(iframeData, currencyCode);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
}

const createBitvilleIframe =  async({gaming_engine_url, client_account, provider_token, wallet_session}, currencyCode) => {
    var lch = new LotteryProductComponentHandler();
    var handleBettingLoginRequest = function (input) {
        app.util.Utils.scrollTop();
    };

    lch.setParam("server", gaming_engine_url);
    lch.setParam("account", client_account);

    provider_token && lch.setParam('customer', provider_token); 
    wallet_session && lch.setParam('client_token', wallet_session);

    var playblockModule = {
        name: "betradar",
        element: "#load-lotteries",
        module: "home",
        currencySymbol: currencyCode,
        locale: "en",
        integration: "minimal",
        bookABet: "yes",
        event_bettingLoginRequest: handleBettingLoginRequest
    };

    lch.createComponent(playblockModule);
}

const Bitville = ({currencyCode}) => {
    const dispatch = useDispatch()
    const [providerData, setProviderData] = useState(null);
    const isLogged = !useSelector(getIsLogged)

    useEffect(() => {
        fetchData();
    }, [isLogged]);

    const fetchData = async () => {
        try {
            setProviderData(null);
            const providerData = await dispatch(getBitvilleIframeData(isLogged, 'desktop'));
            setProviderData(providerData);
        } catch (error) {
          console.log(error)
        }
    };

    return (
        <BitvilleContainer providerData={providerData} currencyCode={currencyCode}></BitvilleContainer>    
    )
};

const mapStateToProps = ( {Auth: {isLogged, user}}, props) => {
    const currencyCode = isLogged ? user.currencyCode : process.env.BITVILLE_SCRIPT_URL.MAIN_CURRENCY_CODE;
    return {currencyCode}
}

export default connect(mapStateToProps)(Bitville);

